// src/components/common/AdPlaceholder.tsx
import React from 'react';
import { Paper, Box, useTheme, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const AD_WIDTH = '160px';

// The root styled component for the ad placeholder.
const AdPlaceholderRoot = styled(Paper)(({ theme }) => ({
    width: AD_WIDTH,
    flexShrink: 0, // Prevent the ad column from shrinking
    margin: theme.spacing(3, 2), // Add vertical and horizontal margin
    padding: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `2px dashed ${theme.palette.divider}`,
    backgroundColor: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[800],
    textAlign: 'center',

    // Hide on screens smaller than 'lg' breakpoint (1200px)
    [theme.breakpoints.down('lg')]: {
        display: 'none',
    },
}));

const AdPlaceholder: React.FC = () => {
    const theme = useTheme();
    return (
        <AdPlaceholderRoot elevation={0} variant="outlined">
            <Typography variant="caption" color="text.secondary">
                Advertisement
            </Typography>
        </AdPlaceholderRoot>
    );
};

export default AdPlaceholder;